// Mock data for TerraHydro Soluções Hidráulicas

export const categories = [
  {
    id: 1,
    name: "Bombas Hidráulicas",
    slug: "bombas-hidraulicas",
    description: "Bombas de pistão axial, engrenagens e palhetas para sistemas hidráulicos",
    icon: "Gauge",
    productCount: 89
  },
  {
    id: 2,
    name: "Motores Hidráulicos",
    slug: "motores-hidraulicos",
    description: "Motores para tratores, caminhões e máquinas agrícolas",
    icon: "Cog",
    productCount: 67
  },
  {
    id: 3,
    name: "Válvulas Hidráulicas",
    slug: "valvulas-hidraulicas",
    description: "Válvulas direcionais, proporcionais e de controle de pressão",
    icon: "Settings2",
    productCount: 124
  },
  {
    id: 4,
    name: "Comandos Hidráulicos",
    slug: "comandos-hidraulicos",
    description: "Comandos manuais e elétricos para controle de sistemas",
    icon: "Joystick",
    productCount: 43
  },
  {
    id: 5,
    name: "Direções Hidrostáticas",
    slug: "direcoes-hidrostaticas",
    description: "Sistemas de direção para máquinas agrícolas e industriais",
    icon: "Steering",
    productCount: 28
  },
  {
    id: 6,
    name: "Mangueiras e Conexões",
    slug: "mangueiras-conexoes",
    description: "Mangueiras de alta pressão e conexões hidráulicas",
    icon: "Cable",
    productCount: 156
  },
  {
    id: 7,
    name: "Vedações",
    slug: "vedacoes",
    description: "Retentores, anéis, kits de reparo e vedações técnicas",
    icon: "Shield",
    productCount: 187
  },
  {
    id: 8,
    name: "Mini Unidades Hidráulicas",
    slug: "mini-unidades",
    description: "Centrais hidráulicas compactas para aplicações especiais",
    icon: "Box",
    productCount: 18
  },
  {
    id: 9,
    name: "Acumuladores",
    slug: "acumuladores",
    description: "Acumuladores de pressão para sistemas hidráulicos",
    icon: "Battery",
    productCount: 31
  },
  {
    id: 10,
    name: "Trocadores de Calor",
    slug: "trocadores-calor",
    description: "Resfriadores de óleo para sistemas hidráulicos",
    icon: "Thermometer",
    productCount: 24
  }
];

export const featuredProducts = [
  {
    id: 1,
    code: "BHA-2890-R",
    name: "Bomba de Pistão Axial A10VSO",
    category: "Bombas Hidráulicas",
    shortDescription: "Bomba de pistão axial de deslocamento variável, alta eficiência",
    image: "https://images.unsplash.com/photo-1682268294076-3af10a9b8c29?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxoeWRyYXVsaWMlMjBwdW1wfGVufDB8fHx8MTc3MTI0MzYwOHww&ixlib=rb-4.1.0&q=85",
    applications: [
      "Máquinas injetoras",
      "Prensas hidráulicas",
      "Sistemas móveis"
    ],
    specifications: {
      displacement: "18, 28, 45, 71, 100, 140, 180 cc/rot",
      maxPressure: "280 bar (contínua) / 350 bar (picos)",
      maxSpeed: "1800 rpm",
      fluidType: "Óleo mineral HL, HLP"
    }
  },
  {
    id: 2,
    code: "MHA-1567-X",
    name: "Motor Hidráulico Orbital BMR",
    category: "Motores Hidráulicos",
    shortDescription: "Motor orbital de alto torque para aplicações agrícolas pesadas",
    image: "https://images.unsplash.com/photo-1682268294146-13a263ae7224?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxoeWRyYXVsaWMlMjBwdW1wfGVufDB8fHx8MTc3MTI0MzYwOHww&ixlib=rb-4.1.0&q=85",
    applications: [
      "Tratores agrícolas",
      "Equipamentos de construção",
      "Misturadores industriais"
    ],
    specifications: {
      displacement: "50, 80, 100, 125, 160, 200, 250, 315, 400 cc/rot",
      maxPressure: "280 bar (contínua)",
      maxSpeed: "800 rpm",
      maxTorque: "850 Nm"
    }
  },
  {
    id: 3,
    code: "VLD-4523-P",
    name: "Válvula Direcional Seccional DH40",
    category: "Válvulas Hidráulicas",
    shortDescription: "Válvula seccional de centro aberto para comandos múltiplos",
    image: "https://images.unsplash.com/photo-1759148414485-5f624fe9d1ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwdmFsdmV8ZW58MHx8fHwxNzcxMjQzNjY2fDA&ixlib=rb-4.1.0&q=85",
    applications: [
      "Retroescavadeiras",
      "Pás carregadeiras",
      "Máquinas florestais"
    ],
    specifications: {
      flow: "40 L/min",
      maxPressure: "315 bar",
      sections: "1 a 10 seções",
      connection: "Rosca ou flange SAE"
    }
  },
  {
    id: 4,
    code: "ACM-8921-H",
    name: "Acumulador de Bexiga 10L",
    category: "Acumuladores",
    shortDescription: "Acumulador hidropneumático com bexiga de alta durabilidade",
    image: "https://images.unsplash.com/photo-1682268294152-147fab24bcdc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxoeWRyYXVsaWMlMjBwdW1wfGVufDB8fHx8MTc3MTI0MzYwOHww&ixlib=rb-4.1.0&q=85",
    applications: [
      "Compensação de pulsações",
      "Armazenamento de energia",
      "Absorção de choques"
    ],
    specifications: {
      volume: "10 litros",
      maxPressure: "350 bar",
      preCharge: "90 bar (padrão)",
      material: "Aço carbono / Inox 316L"
    }
  },
  {
    id: 5,
    code: "MUH-3347-C",
    name: "Mini Unidade Hidráulica 2.2kW",
    category: "Mini Unidades Hidráulicas",
    shortDescription: "Central hidráulica compacta com motor trifásico",
    image: "https://images.unsplash.com/photo-1759064776046-45b988af4b6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxoeWRyYXVsaWMlMjBzeXN0ZW18ZW58MHx8fHwxNzcxMjQzNjMyfDA&ixlib=rb-4.1.0&q=85",
    applications: [
      "Elevadores",
      "Prensas pequenas",
      "Máquinas especiais"
    ],
    specifications: {
      motorPower: "2.2 kW / 3 CV",
      voltage: "220V / 380V / 440V",
      tankCapacity: "20 litros",
      pumpFlow: "6.5 L/min a 1450 rpm"
    }
  },
  {
    id: 6,
    code: "TRC-6754-K",
    name: "Trocador de Calor Ar/Óleo",
    category: "Trocadores de Calor",
    shortDescription: "Resfriador de óleo com ventilador 12V para aplicações móveis",
    image: "https://images.unsplash.com/photo-1682268294196-8a8dd14c0326?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHw0fHxoeWRyYXVsaWMlMjBwdW1wfGVufDB8fHx8MTc3MTI0MzYwOHww&ixlib=rb-4.1.0&q=85",
    applications: [
      "Sistemas móveis agrícolas",
      "Caminhões com PTO",
      "Equipamentos florestais"
    ],
    specifications: {
      coolingCapacity: "15 kW a 80°C",
      flow: "45 L/min",
      fanVoltage: "12V / 24V DC",
      connections: "1\" BSP"
    }
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Você envia a foto ou código",
    description: "Tire uma foto da peça ou nos envie o código de identificação pelo WhatsApp",
    icon: "Camera"
  },
  {
    step: 2,
    title: "Identificamos a aplicação",
    description: "Nossa equipe técnica analisa e identifica exatamente qual componente você precisa",
    icon: "Search"
  },
  {
    step: 3,
    title: "Indicamos a peça correta",
    description: "Fornecemos especificações técnicas completas e confirmamos compatibilidade",
    icon: "CheckCircle2"
  },
  {
    step: 4,
    title: "Enviamos para todo o Brasil",
    description: "Preparamos e despachamos sua peça com segurança e rastreamento completo",
    icon: "Truck"
  }
];

export const differentials = [
  {
    icon: "Award",
    title: "Peças Originais",
    description: "Componentes certificados de fabricantes homologados"
  },
  {
    icon: "Users",
    title: "Suporte Técnico Especializado",
    description: "Equipe com mais de 15 anos de experiência em hidráulica"
  },
  {
    icon: "Zap",
    title: "Envio Rápido",
    description: "Estoque próprio e logística ágil para todo o Brasil"
  },
  {
    icon: "Target",
    title: "Aplicação Correta Garantida",
    description: "Identificação precisa para evitar erros e retrabalho"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Carlos Eduardo Silva",
    role: "Proprietário - Oficina Hidráulica Maquinatech",
    location: "Ribeirão Preto - SP",
    text: "A TerraHydro resolveu um problema crítico que tínhamos há semanas. Enviamos foto de uma bomba antiga e em 2 horas já tínhamos a identificação correta e a peça disponível. Profissionalismo excepcional.",
    rating: 5
  },
  {
    id: 2,
    name: "Roberto Martins",
    role: "Gerente de Manutenção",
    location: "Goiânia - GO",
    text: "Trabalho com hidráulica há 20 anos e a TerraHydro é referência em qualidade e atendimento técnico. Sempre encontro as peças certas, com especificações completas e entrega rápida.",
    rating: 5
  },
  {
    id: 3,
    name: "Ana Paula Costa",
    role: "Engenheira Mecânica - AgroSul Equipamentos",
    location: "Uberlândia - MG",
    text: "O suporte técnico é diferenciado. Eles não apenas vendem a peça, mas ajudam a entender a aplicação e garantem compatibilidade total. Isso evita erro e economia no final.",
    rating: 5
  }
];

export const companyInfo = {
  name: "TerraHydro Soluções Hidráulicas",
  slogan: "A peça certa, na aplicação correta.",
  whatsapp: "5562991953619",
  phone: "556233001656",
  email: "contato@terrahydro.com.br",
  address: {
    street: "Av. Industrial, 1234",
    city: "Goiânia",
    state: "GO",
    zipcode: "74000-000"
  },
  social: {
    instagram: "@terrahydro",
    facebook: "terrahydrosolucoes",
    linkedin: "company/terrahydro"
  },
  about: {
    founded: 2010,
    description: "A TerraHydro Soluções Hidráulicas é especializada na distribuição de componentes hidráulicos de alta performance para os setores agrícola e industrial. Com mais de 15 anos de experiência no mercado, nossa missão é fornecer não apenas peças, mas soluções técnicas completas que garantam a aplicação correta e máxima eficiência dos sistemas hidráulicos.",
    mission: "Fornecer componentes hidráulicos de excelência com suporte técnico especializado, garantindo a identificação precisa e aplicação correta de cada peça.",
    vision: "Ser a referência nacional em distribuição técnica de componentes hidráulicos, reconhecida pela expertise e qualidade do atendimento consultivo.",
    values: [
      "Expertise técnica",
      "Qualidade garantida",
      "Atendimento consultivo",
      "Agilidade na entrega",
      "Transparência comercial"
    ]
  }
};

// Generate more products for catalog (simulating 400 products)
export const generateAllProducts = () => {
  const allProducts = [...featuredProducts];
  
  const productTemplates = [
    { category: "Bombas Hidráulicas", prefix: "BHA", types: ["Pistão Axial", "Engrenagens", "Palhetas", "Êmbolo"] },
    { category: "Motores Hidráulicos", prefix: "MHA", types: ["Orbital", "Pistão", "Engrenagens"] },
    { category: "Válvulas Hidráulicas", prefix: "VLD", types: ["Direcional", "Alívio", "Retenção", "Controle Fluxo"] },
    { category: "Vedações", prefix: "VED", types: ["Retentor", "Anel O-ring", "Kit Reparo", "Gaxeta"] },
    { category: "Mangueiras e Conexões", prefix: "MNG", types: ["Mangueira SAE", "Conexão JIC", "Adaptador", "Terminal"] }
  ];
  
  // This would generate 400 products in real implementation
  // For now, we keep the featured products as primary examples
  
  return allProducts;
};
